import styles from "../index.module.scss";
import React from "react";

export default [
  {
    label: "name",
    title: "Nome *",
  },
  {
    label: "surname",
    title: "Cognome *",
  },
  {
    label: "email",
    title: "Email *",
  },
  {
    label: "email_verify",
    title: "Verifica Email *",
  },
  {
    label: "mobile",
    title: "Cellulare *",
  },
  {
    label: "institution",
    title: "Istituzione scolastica, ente o associazione *",
  },
  {
    label: "fiscal_code",
    title: "Codice meccanografico, CF o P.Iva *",
  },
  {
    label: "phone",
    title: "Telefono",
  },
  {
    label: "province",
    title: "Provincia *",
  },
  {
    label: "city",
    title: "Città *",
  },
  {
    label: "privacy_policy",
    link:
      <a
        href='https://myedufamily.it/documenti/privacy-policy'
        className={styles.formLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        Informativa privacy
      </a>,
    title:
      " Consento al trattamento dei dati nel rispetto dell'informativa ex artt.13 D. lgs. 196/2003 e 13 del GDPR " +
      "(Reg. Eur. 679/2016) per il trattamento dei dati personali. *"
  },
  {
    label: "advertising_policy",
    title:
      "Vorrei essere contattato e/o informato da parte di Fme Education S.p.A. su iniziative promozionali, " +
      "attraverso i seguenti canali: e-mail, posta cartacea, telefono/servizi di messaggistica. *",
  },
  {
    label: "promotions_policy",
    title:
      "Vorrei, inoltre, ricevere materiale pubblicitario, comunicazioni commerciali inerenti i nostri servizi, " +
      "informazioni sui corsi della nostra società, presentazioni o iniziative di P.R., di studi, di convegni, anche per il tramite di commerciali nonché di nostri agenti. *",
  },
];
